module.exports = __webpack_public_path__ + "twitter-logo.c2f1acf6f29c52f793f66b65ba91d49f.svg";